import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
function getLinearProgressUtilityClass(slot) {
  return generateUtilityClass("MuiLinearProgress", slot);
}
generateUtilityClasses("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
export {
  getLinearProgressUtilityClass
};
//# sourceMappingURL=linearProgressClasses.es.js.map
